import React from 'react';
import PropTypes from 'prop-types';
import OutOfOffice from '@fiverr-private/out_of_office/src/OutOfOffice';
import SafePureComponent from '../shared/SafePureComponent';
import { FIT_MODAL_CLASS } from '../../utils/constants';

import './style.scss';

const GigOutOfOffice = (props, context) => {
    const { outOfOffice, isLoggedIn, isPageOwner } = props;
    const { requestContext, general } = context;

    if (!outOfOffice) {
        return null;
    }

    const outOfOfficeProps = {
        type: 'gig',
        is_page_owner: isPageOwner,
        profile_image_url: outOfOffice.profilePhoto,
        gig_id: general.gigId,
        username: outOfOffice.username,
        end_date: outOfOffice.endDate,
        reason: outOfOffice.awayReason,
        message_for_buyer: outOfOffice.awayMessage,
        allow_contact: outOfOffice.allowContact,
        is_on_vacation: true,
        modalCustomName: FIT_MODAL_CLASS
    };

    if (isLoggedIn) {
        outOfOfficeProps.user_id = requestContext.current_user.id;
    }

    return (
        <OutOfOffice {...outOfOfficeProps}/>
    );
};

GigOutOfOffice.propTypes = {
    outOfOffice: PropTypes.shape({
        username: PropTypes.string.isRequired,
        endDate: PropTypes.number.isRequired,
        profilePhoto: PropTypes.string.isRequired,
        allowContact: PropTypes.bool,
        awayReason: PropTypes.string,
        awayMessage: PropTypes.string
    }),
    isPageOwner: PropTypes.bool
};

GigOutOfOffice.contextTypes = {
    requestContext: PropTypes.object,
    general: PropTypes.object
};

export { GigOutOfOffice };
export default SafePureComponent(GigOutOfOffice);
